import TemplatePage, {TemplatePageProps} from "../template_page/template_page";
import {LEFT_ITEM_UNDEFINED, Page} from "../../model/page";
import {API_CONFIG} from "../../config/api_config";
import {getI18n} from "react-i18next";
import {ProfessorData} from "../../luiss_components/c69_faculty/professor_component";



class CattedreonlinePage extends TemplatePage {

    constructor(props: TemplatePageProps) {
        super(props);

        let path = this.props.path;
        if (path && path.startsWith("/cattedreonline/corso")) {
            // to compute the backend path, we have first to remove the first part "/cattedreonline/corso"
            // from the path being shown in the frontend
            path = path.substring(21);
        }

        this.dataUrl = `${API_CONFIG.BASE_URL}${API_CONFIG.PROFESSORSHIPS_PATH}/${this.props.language}${path}`;
    }

    

    prefilterData(data: any): Page {
        return {
            title: data.title,
            two_columns: true,
            desktop_navbar_color: "dark",
            mobile_navbar_color: "dark",
            left_column: [
                ...data.professors ?
                    data.professors.map((prof: ProfessorData) => ({
                        type: "professor",
                        dataObj: prof
                    }))
                    :
                    [LEFT_ITEM_UNDEFINED],
                data.video ?
                    {
                        type: "left_video",
                        dataObj: {
                            video: data.video
                        }
                    }
                :
                    LEFT_ITEM_UNDEFINED,
            {
                type: "button_action",
                dataObj: {
                    url: data.learnUrl,
                    label: getI18n().t("SCHOLARSHIP PAGE open luiss learn")
                }
            }],
            components: [{
                type: "professorship",
                dataObj: data
            }],
            path: this.props.path
        }
    }

    onDataLoaded(data: Page) {
        super.onDataLoaded(data);

        this.props.breadcrumbCallback([
            { title: "Cattedre Online", url: "/cattedreonline" },
            { title: data.title, url: this.props.path }
        ]);
    }
}

export default CattedreonlinePage;